import React from "react";
import { Li, ListItem } from "./Components";
import { Typography } from "@material-ui/core";
import inf_dec_ext from "../img/sswpIcons/Infestation/inf_dec_ext.png";
import inf_haz_lev from "../img/sswpIcons/Infestation/inf_haz_lev.png";
import inf_spe_ppe from "../img/sswpIcons/Infestation/inf_spe_ppe.png";
import inf_sur from "../img/sswpIcons/Infestation/inf_sur.png";
import inf_wei_dis from "../img/sswpIcons/Infestation/inf_wei_dis.png";
import inf_sit_spe_met from "../img/sswpIcons/Infestation/inf_spe_sit_spe_met.png";

export default {
    icon: inf_haz_lev,
    name: "Infestation",
    text: "",
    icons: {
        inf_sur: {
            name: "Surveying",
            icon: inf_sur,
            text: (
                <ul>
                    <ListItem text=" Before commencing, the area should be visually assessed for asbestos or infestation." />
                    <ListItem text="Workers can only enter the area after appropriate controls have been put in place." />
                </ul>
            )
        },
        inf_wei_dis: {
            name: "Weil's Disease/ Hygiene",
            icon: inf_wei_dis,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Where exposure to Weils Disease is known or
                            suspected,{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Wear protective clothing, including overalls and gloves" />
                            <ListItem text="Cover all cuts, abrasions and other breaks with waterproof dressing AND/or gloves." />
                            <ListItem text="Follow good basic hygiene controls including regular hand-washing and avoiding hand to mouth/eye contact" />
                            <ListItem text="Take rest breaks, including meal and drink breaks, away from work area" />
                            <ListItem text="Wash cuts and grazes immediately with soap and running water." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        inf_dec_ext: {
            name: "Decontamination/ Extermination",
            icon: inf_dec_ext,
            text: (
                <ul>
                    <ListItem text="If using chemicals/ agents that area may require decontamination before you can enter without respiratory or skin protection." />
                    <ListItem text="If there is evidence of rodents (visual or droppings present etc), extermination services will be required prior to undertaking works." />
                    <ListItem text="Only authorised personnel are allowed to enter until either process is complete." />
                </ul>
            )
        },
        inf_spe_ppe: {
            name: "Specialist PPE",
            icon: inf_spe_ppe,
            text: (
                <ul>
                    <ListItem text="Specialist PPE must be worn when entering an infested building." />
                    <ListItem text="The PPE must be of the correct size and fit for purpose. It must be CE marked, and you must follow the manufacture’s instructions." />
                    <ListItem text=" Ensure that is adequately cleaned and maintained, and has not passed any expiry dates. Other PPE items worn must be compatible with the specialist PPE." />
                    <ListItem text=" All PPE should be donned prior to opening any containers, and all persons not wearing PPE must be kept outside the established danger zone." />
                </ul>
            )
        },
        inf_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: inf_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
